<template>
  <div id="scale" style="height: 160px; min-width: 1500px;">
    <div class="d-flex">
      <div class="legend">
        <p class="legend-item"><span class="legend-item-color-warning"></span><span class="legend-item-text text-warning fw-bolder"> - postoje z włączonym silnikiem</span></p>
        <p class="legend-item"><span class="legend-item-color-info"></span><span class="legend-item-text text-info fw-bolder"> - postoje</span></p>
        <p class="legend-item"><span class="legend-item-color-danger"></span><span class="legend-item-text text-danger fw-bolder"> - aktywność</span></p>
      </div>
      <div class="text-center mt-4 mx-auto">
        <button
          class="btn btn-info text-white me-1"
          @click="getWorkingTimes(48)"
          :disabled="disabledButtons"
        >
          <i class="fa-solid fa-clock"></i>
          Ostatnie 48h
        </button>
        <button class="btn btn-danger" @click="closeMap">
          <i class="fa-solid fa-circle-xmark"></i>
          Zamknij widok mapy
        </button>
        <button
          class="btn btn-info text-white ms-1"
          @click="getWorkingTimes(24)"
          :disabled="disabledButtons"
        >
          <i class="fa-solid fa-clock"></i>
          Ostatnie 24h
        </button>
      </div>
    </div>
    <div>
      <div v-if="routeActivitiesGroups">
        <div>
          <div
            v-if="routeActivitiesGroups.first.length > 0"
            class="progress"
          >
            <div
              v-for="(firstActivity, index) in routeActivitiesGroups.first"
              :key="index"
              class="progress-bar"
              :class="'bg-' + firstActivity.type"
              :style="'width: ' + firstActivity.width * 2 + '%;'"
              role="progressbar"
            ></div>
          </div>
        </div>
        <ul class="scale-list" v-if="scalePeriod === 48">
          <li class="scale-list-item" v-for="n in hoursScale" :key="n">
            <span class="scale-list-item-text">{{ n === 0 ? 23 : n - 1 }}:00</span>
          </li>
        </ul>
        <div :class="{ 'minus-margin-chart': scalePeriod === 48 }">
          <div
            v-if="routeActivitiesGroups.second.length > 0"
            class="progress"
          >
            <div
              v-for="(secondActivity, index) in routeActivitiesGroups.second"
              :key="index"
              class="progress-bar"
              :class="'bg-' + secondActivity.type"
              :style="'width: ' + secondActivity.width * 2 + '%;'"
              role="progressbar"
            ></div>
          </div>
        </div>
        <ul class="scale-list">
          <li class="scale-list-item" v-for="n in hoursScale" :key="n">
            <span class="scale-list-item-text">{{ n }}:00</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import L from 'leaflet'

export default {
  name: 'StatsChart',
  props: ['task', 'period', 'rowId'],
  data () {
    return {
      fulltime: 0,
      routeActivities: [],
      routeActivitiesGroups: null,
      hoursScale: [],
      disabledButtons: false,
      scalePeriod: 24,
      activitiesRouting: null
    }
  },
  methods: {
    closeMap () {
      this.$parent.$parent.closeMapService()
    },

    setHoursScale () {
      const tempDate = new Date(Date.now() - (3600 * 1000 * 24))
      let startDate = tempDate.getHours()

      this.hoursScale = []

      for (let i = 0; i < 24; i++) {
        this.hoursScale.push(startDate)
        startDate = (startDate + 2 > 24 ? 0 : startDate + 1)
      }

      this.hoursScale.push(startDate)
    },

    async getWorkingTimes (period = 24) {
      this.disabledButtons = true
      this.fulltime = (((new Date().getTime() - new Date(Date.now() - (3600 * 1000 * period)).getTime()) / 60000)).toFixed(2)

      this.routeActivitiesGroups = null
      this.scalePeriod = period

      if (this.task) {
        this.setHoursScale()
        this.$parent.$parent.initMapService(this.task, this.rowId, this.task.vehicleId, false)

        const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }, params: { period: period } }
        const vehicleRoute = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle/${this.task.vehicleId}/Route`, axiosConfig)).data
        const routeActivities = vehicleRoute.activities

        let currentWidth = 0

        this.routeActivitiesGroups = {
          first: [],
          second: []
        }

        routeActivities.map(activity => {
          let activityTypeClass = 'light'

          if (activity.activityType === 'ParkingOnEngine') {
            activityTypeClass = 'warning'
          }

          if (activity.activityType === 'Parking') {
            activityTypeClass = 'info'
          }

          if (activity.activityType === 'Driving') {
            activityTypeClass = 'danger'
          }

          const activityStartTime = new Date(activity.startDate)
          const activityEndTime   = new Date(activity.endDate)
          const timeDifference    = activityEndTime.getTime() - activityStartTime.getTime()
          const diffInMinutes     = Math.round(timeDifference / 60000)
          const barWidth          = (diffInMinutes * 100) / this.fulltime

          if (period === 24) {
            this.routeActivitiesGroups.first.push({
              type: activityTypeClass,
              width: barWidth
            })
          } else if (period === 48) {
            currentWidth += barWidth

            if (currentWidth < 50) {
              this.routeActivitiesGroups.first.push({
                type: activityTypeClass,
                width: barWidth
              })
            } else {
              this.routeActivitiesGroups.second.push({
                type: activityTypeClass,
                width: barWidth
              })
            }
          }
        })

        if (period === 48) {
          let remainingWidth = 0.00
          let nextScaleWidth = 0.00

          let firstScaleWidth  = 0.00
          let secondScaleWidth = 0.00

          this.routeActivitiesGroups.first.map(a => firstScaleWidth += a.width)
          this.routeActivitiesGroups.second.map(b => secondScaleWidth += b.width)

          if (secondScaleWidth > 50) {
            remainingWidth = 50 - firstScaleWidth
            nextScaleWidth = this.routeActivitiesGroups.second[0].width - remainingWidth

            this.routeActivitiesGroups.first.push({
              type: this.routeActivitiesGroups.second[0].type,
              width: remainingWidth
            })

            this.routeActivitiesGroups.second[0].width = nextScaleWidth
          }
        }

        this.setActivitiesRoute(vehicleRoute)
      }

      this.disabledButtons = false
    },

    setActivitiesRoute (vehicleRoute) {
      const routeWayPoints = vehicleRoute.route.map(point => [point.positionLatitude, point.positionLongitude])
      let activitiesLatLngs = []

      routeWayPoints.forEach(wayPoint => {
        activitiesLatLngs.push(L.latLng(wayPoint[0], wayPoint[1]))
      })

      activitiesLatLngs = activitiesLatLngs.filter((point, index) => index % 15 === 0 || (index + 1) === activitiesLatLngs.length || index === 0)

      this.activitiesRouting = L.Routing.control({
        waypoints: activitiesLatLngs,
        show: false,
        routeWhileDragging: false,
        lineOptions: {
          styles: [{ color: 'blue' }]
        },
        createMarker: function () { return null }
      }).addTo(this.$parent.$parent.map)
    }
  }
}
</script>

<style scoped>
.progress-bar.bg-none {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  transition: width .6s ease;
}
.scale-list {
  list-style: none;
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  justify-content: flex-start;
  padding: 0;
}
.scale-list-item {
  flex-grow: 1;
}
.scale-list-item-line {
  display: block;
}
.scale-list-item-text {
  display: block;
}
.progress-bar .bg-primary {
  background-color: transparent !important;
}
.legend  {
  text-align: left;
}
.legend .progress {
  position: absolute;
  width: 100%;
}
.legend-item {
  margin: 0px;
}
.legend-item-color-info {
  width: 20px;
  height: 20px;
  display: inline-block;
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb),var(--bs-bg-opacity)) !important;
}
.legend-item-color-warning {
  width: 20px;
  height: 20px;
  display: inline-block;
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb),var(--bs-bg-opacity)) !important;
}
.legend-item-color-danger {
  width: 20px;
  height: 20px;
  display: inline-block;
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb),var(--bs-bg-opacity)) !important;
}
.legend-item-text {
  display: inline-block;
  position: relative;
  top: -5px;
  padding-left: 5px;
}

.minus-margin-chart {
  margin-top: -20px;
}
</style>
